import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Globals, LogOut as sharedLogOut } from '../globalfunctions.js';
import simpleSessionTimer from '../utils/simpleSessionTimer';
import mfaEnforcer from '../utils/mfaEnforcer';
import { isImpersonating, exitImpersonation } from '../utils/impersonation';
import { useIsMobile } from '../hooks/mobile';
import PortalMobileChrome from './mobile/PortalMobileChrome';
import './PortalShell.css';

const NAV_ITEMS = [
  { path: '/portal/invoices', label: 'Invoices' },
  { path: '/portal/subscriptions', label: 'Subscriptions' },
  { path: '/portal/quotes', label: 'Quotes' },
  { path: '/portal/tickets', label: 'Support' },
  { path: '/portal/help', label: 'Help' },
  { path: '/portal/domains', label: 'Domains' },
  { path: '/portal/uptime', label: 'Outages' },
  { path: '/portal/cpanel', label: 'Resources' }
];

// The staff PageShell (Navbar + Sidebar) is built around roleManager's
// permission list, which is deliberately empty for the "customer" role -
// reusing it here would just show an empty sidebar. Customers get this
// much smaller shell instead: a handful of fixed links, no admin nav.
export default function PortalShell({ children }) {
  const location = useLocation();
  const navigate = useNavigate();
  const impersonating = isImpersonating();
  const isMobile = useIsMobile();

  const handleLogout = () => {
    simpleSessionTimer.clearSession();
    mfaEnforcer.clear2FASession();
    Globals.UserName = '';
    Globals.UserType = '';
    Globals.LoginTime = null;
    Globals.FirstName = '';
    Globals.LastName = '';
    sharedLogOut();
  };

  const handleExitImpersonation = async () => {
    await exitImpersonation();
    navigate('/users');
  };

  if (isMobile) {
    return (
      <div className="portal-shell">
        <PortalMobileChrome impersonating={impersonating} onExitImpersonation={handleExitImpersonation} onLogout={handleLogout} />
        <main className="portal-content">{children}</main>
      </div>
    );
  }

  return (
    <div className="portal-shell">
      {impersonating && (
        <div className="portal-impersonation-banner">
          <span>
            Viewing as <strong>{Globals.FirstName || Globals.UserName}</strong> (read-only)
          </span>
          <button type="button" onClick={handleExitImpersonation}>Exit &amp; return to admin</button>
        </div>
      )}
      <header className="portal-header">
        <Link to="/portal" className="portal-logo">
          <img src="/logo192.png" alt="Vader Design" />
        </Link>
        <nav className="portal-nav">
          {NAV_ITEMS.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className={location.pathname.startsWith(item.path) ? 'active' : ''}
            >
              {item.label}
            </Link>
          ))}
        </nav>
        <div className="portal-user">
          <Link to="/portal/account" className={location.pathname.startsWith('/portal/account') ? 'active' : ''}>{Globals.FirstName || Globals.UserName}</Link>
          <button type="button" onClick={handleLogout}>Log Out</button>
        </div>
      </header>
      <main className="portal-content">{children}</main>
    </div>
  );
}
